export default {
  state: {},

  mutations: {
    addOrUpdateSale: (store, sale) => (store.sale = sale),

    cleanSale: (store, _) => (store.sale = {}),

    setObservations: (store, obs) => store.sale.observacoes = obs
  },

  getters: {
    getSale: (store, sale) => store.sale
  }
}


// WEBPACK FOOTER //
// ./src/store/storeSale.js